export enum BuilderCharacteristic {
  SPECIFIC_STATUTE = -1,
  OFFENSE_GROUPING = -2,
  ENHANCEMENT = -3,
  STRIKE_ALLEGED = -4,
  PRIOR_ALLEGATION = -5,
  CASE_DISPOSITION = -6,
  AGE = -7,
  GENDER = -8,
  DATE_WINDOW = -9,
  CODEFENDANT = -10,
}
